
import { Mixins, Component, Prop } from 'vue-property-decorator';
import FeatureFlagMixin from '@/features/common/mixins/featureFlagMixin';

@Component
export default class SettingsSelect extends Mixins(FeatureFlagMixin) {
  @Prop({ default: false }) isNotifications!: boolean;

  protected featureKeysToLoad = ['updatesPreferences'];

  private notificationsItems = [
    {
      value: 'shipments',
      text: this.$t('preferences.notifications.shipments'),
      icon: 'mdi-package-variant-closed',
    },
    {
      value: 'packages',
      text: this.$t('preferences.notifications.packages'),
      icon: 'mdi-package-variant',
    },
    {
      value: 'serviceLevelAndPricing',
      text: this.$t('preferences.notifications.serviceAndPricing'),
      icon: 'mdi-clock-time-nine',
    },
    {
      value: 'customs',
      text: this.$t('preferences.notifications.customs'),
      icon: 'mdi-account-tie',
    },
    {
      value: 'pickupOrDropOff',
      text: this.$t('preferences.notifications.pickupOrDropOff'),
      icon: 'mdi-truck',
    },
    {
      value: 'general',
      text: this.$t('preferences.notifications.general'),
      icon: 'mdi-alert-circle',
    },
  ];

  private get preferencesItems() {
    const list = [
      {
        value: 'shippingSettings',
        text: this.$t('preferences.shippingSettings'),
        icon: 'mdi-package-variant-closed',
      },
      {
        value: 'customs',
        text: this.$t('preferences.customsSettings'),
        icon: 'mdi-account-tie',
      },
      {
        value: 'printSettings',
        text: this.$t('preferences.printSettings'),
        icon: 'mdi-printer',
      },
      {
        value: 'schedulePickup',
        text: this.$t('preferences.schedulePickup'),
        icon: 'mdi-calendar-month',
      },
      {
        value: 'ecommerce',
        text: this.$t('preferences.ecommerce'),
        icon: 'mdi-cart',
      },
      {
        value: 'carrierFilters',
        text: this.$t('preferences.carrierFilters'),
        icon: 'mdi-truck',
      },
    ];

    if (this.featureFlags.updatesPreferences) {
      list.push({
        value: 'updatesPreferences',
        text: this.$t('preferences.updatesPreferences'),
        icon: 'mdi-email',
      });
    }

    return list;
  }

  private selectedItem = this.$route.query.content;

  private handleInput(content): void {
    this.$router.push({ query: { content } });
  }
}
